import React from "react";
import { RiRefreshFill } from "react-icons/ri";
import TextComponent from "./TextComponent";

interface MessageProps {
  role: string;
  content: string;
  dateTime: string;
  audioUrl?: string | null;
  message_id: string;
  updateAudioUrl: (messageId: string, content: string) => void;
  isVoiceEnabled: boolean;
}

function Message({ role, content, dateTime, audioUrl, message_id, updateAudioUrl, isVoiceEnabled }: MessageProps) {

  // Function to handle reload button click
  const handleReload = async (): Promise<void> => {
    try {
      updateAudioUrl(message_id, content); // Invoke the callback function to update audioUrl
    } catch (error) {
      console.error("Error reloading audio:", error);
    }
  };

  return (
    <div className="">
      {/* User message */}
      {role === "user" ? (
        <div className="chat chat-start">
          <div className="chat-header">
            You{" "}
          </div>
          <div className="chat-bubble">
            {" "}
            <TextComponent text={content} />
          </div>
          <div className="chat-footer opacity-50"></div>
        </div>
      ) : (
        // Assistant message
        <div className="chat chat-end">
          <div className="chat-header">
            Teacher{" "}
          </div>
          <div className="chat-bubble">
            <TextComponent text={content} />
          </div>
          <div className="chat-footer opacity-50">
            {audioUrl ? (
              <div>
                <audio id={message_id} controls autoPlay src={audioUrl} />
              </div>
            ) : (
              <div className="flex items-center gap-2">
                {!isVoiceEnabled && (
                  <span className="text-xs text-gray-500">Voice disabled</span>
                )}
                <button onClick={handleReload} title="Generate voice for this message">
                  <RiRefreshFill />
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default Message;
